
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M235.5 44.5c-16.9 3.1-36.6 11.6-49.5 21.4-8.4 6.3-21.4 19.9-26.9 28-6.4 9.4-13.7 25.3-16.7 36.6-3.5 13.2-4.4 35.5-2.1 49 2.9 16.2 9.8 33.4 19 47 5.3 7.8 18.5 21.4 26.7 27.6 8.1 6.1 23 13.8 33.3 17.3 22.7 7.5 50.7 7.5 73.2 0 17.2-5.7 31.2-14.2 44.3-26.8 14.5-13.9 24-28.8 30.3-47.4 7.8-23.1 8-50.8.3-73.7-3.5-10.5-11.2-25.4-17.3-33.5-6.2-8.2-19.8-21.4-27.6-26.7-13.4-9-30.8-16.1-46.3-18.8-10.2-1.8-31-1.8-40.7 0"}}),_c('path',{attrs:{"d":"M150 261.2c-14.3 9.7-29.4 25-39.9 40.6-21.4 31.7-30.2 76.9-21 106.8 2.4 7.7 8.4 20.1 12.3 25.4 8.8 11.7 23.5 23.3 36.7 28.8 15.3 6.3 13.2 6.2 117.9 6.2 104.6 0 102.6.1 117.8-6.2 14.1-5.8 29.3-18 37.5-29.9 4.7-7 10.5-19.8 12.8-28.4 3-11.4 3-31.7 0-47.3-7.4-38-27.6-70.5-57.6-92.7-11.7-8.6-10.6-8.5-18.3-1.4-9.6 8.8-25.6 19-38 24.3-36.2 15.2-74.5 14.9-110.5-.9-11.4-5.1-26.5-14.9-35.9-23.4-3.6-3.4-6.8-6.1-7.1-6.1-.2 0-3.2 1.9-6.7 4.2"}})])
          )
        }
      }
    